import {
  GET_PRICING_DETAILS,
  UPDATE_BILLING_DETAILS,
  UPDATE_SELECTED_CURRENCY,
  INITIALIZE_SUBSCRIPTION_CHECKOUT,
  RESET_SUBSCRIPTION_CHECKOUT,
  SET_SUBSCRIPTION_PAYMENT_PROCESSING,
  SET_SUBSCRIPTION_PAYMENT_SUCCESS,
  SET_SUBSCRIPTION_PAYMENT_ERROR
} from '../reducers/subscriptionReducer'
import type { ReduxAxiosAction, ReduxAction } from './common'
import type { BillingDetailsModel } from '../../types/generated/models/billing-details-model'

/**
 * Get pricing details including billing info and available currencies
 */
export const getPricingDetails = (): ReduxAxiosAction => {
  return {
    type: GET_PRICING_DETAILS,
    payload: {
      request: {
        url: 'subscription/pricing-details',
        method: 'GET'
      }
    }
  }
}

/**
 * Update billing details in state
 */
export const updateBillingDetails = (billingDetails: Partial<BillingDetailsModel>): ReduxAction<Partial<BillingDetailsModel>> => {
  return {
    type: UPDATE_BILLING_DETAILS,
    payload: billingDetails
  }
}

/**
 * Update selected currency
 */
export const updateSelectedCurrency = (currency: string): ReduxAction<string> => {
  return {
    type: UPDATE_SELECTED_CURRENCY,
    payload: currency
  }
}

/**
 * Initialize checkout - creates Stripe subscription with billing details and currency
 */
export const initializeSubscriptionCheckout = (
  billingDetails: Partial<BillingDetailsModel> | null,
  currency: string,
  clientRequestId: string
): ReduxAxiosAction => {
  return {
    type: INITIALIZE_SUBSCRIPTION_CHECKOUT,
    payload: {
      request: {
        url: 'subscription/create-payment-intent',
        method: 'POST',
        data: {
          currency: currency || 'gbp',
          billingDetails: billingDetails || null,
          clientRequestId
        }
      }
    }
  }
}

/**
 * Reset checkout state
 */
export const resetSubscriptionCheckout = (): ReduxAction => {
  return {
    type: RESET_SUBSCRIPTION_CHECKOUT
  }
}

/**
 * Set payment processing state
 */
export const setSubscriptionPaymentProcessing = (): ReduxAction => {
  return {
    type: SET_SUBSCRIPTION_PAYMENT_PROCESSING
  }
}

/**
 * Set payment success
 */
export const setSubscriptionPaymentSuccess = (): ReduxAction => {
  return {
    type: SET_SUBSCRIPTION_PAYMENT_SUCCESS
  }
}

/**
 * Set payment error
 */
export const setSubscriptionPaymentError = (error?: string): ReduxAction<string | undefined> => {
  return {
    type: SET_SUBSCRIPTION_PAYMENT_ERROR,
    payload: error
  }
}

/**
 * Log terms and conditions acceptance
 */
export const logTermsAcceptance = (amount: number, version: string, language: string, subscriptionId?: string | null): ReduxAxiosAction => {
  return {
    type: 'LOG_TERMS_ACCEPTANCE',
    payload: {
      request: {
        url: 'subscription/log-terms-acceptance',
        method: 'POST',
        data: {
          amount,
          acceptedAt: new Date().toISOString(),
          version,
          language,
          subscriptionId: subscriptionId || null
        }
      }
    }
  }
}
